<template>
    <form class="form" v-on:submit="pressFormSubmit">
        <div class="input-field form-input">
            <label for="your-title">Title *</label>
            <input type="text" placeholder="Title" v-model="title" id="your-title">
        </div>
        <div class="input-file-field form-input">
            <p>Video Cover Image *</p>
            <label for="image">
                <span>{{imageName}}</span>
                <span>Choose File</span>
            </label>
            <input type="file" id="image" ref="img" v-on:change="handleImageFileUpload">
        </div>
        <div class="input-file-field form-input up-video">
            <a href="javascript:void(0)" class="active" v-on:click="videoUpload" data-id="youtube">YouTube</a>
            <a href="javascript:void(0)" v-on:click="videoUpload" data-id="upload">Upload</a>
        </div>
        <div class="input-file-field form-input" v-if="!youtubeFlag">
            <p>Upload Video *</p>
            <label for="video">
                <span>{{videoName}}</span>
                <span>Choose File</span>
            </label>
            <input type="file" id="video" ref="video" v-on:change="handleVideoFileUpload">
        </div>
        <div class="input-field form-input" v-if="youtubeFlag">
            <label for="youtube">YouTube Link *</label>
            <input type="text" placeholder="YouTube Link" v-model="youtube" id="youtube">
        </div>


        <div class="input-select-field form-input" v-if="admin">
            <label for="your-profession">Link Artist * <span></span></label>
            <select id="your-profession" v-model="userId">
                <option value="">Choose Artist</option>
                <option :value="list._id" v-for="(list) in artists" v-if="artists" v-bind:key="list._id">{{list.name}} ({{list.email}})</option>
            </select>
        </div>

        <div class="input-textarea-field form-input" v-if="FormSubmited">
            <Progress interval="500" />
        </div>

        <div class="input-submit">
            <button type="submit" v-if="!FormSubmited">SUBMIT</button>
            <span v-if="FormSubmited">SUBMIT...</span>
        </div>
    </form>
</template>

<script>
    import axios from 'axios'
    import Vue from 'vue'
    import VueToast from 'vue-toast-notification'
    import 'vue-toast-notification/dist/index.css'
    import Progress from "./Progress";
    import $ from 'jquery'
    Vue.use(VueToast)
    export default {
        name: 'videoUpload',
        components: {Progress},
        props: ['admin', 'campaignId'],
        data () {
            return {
                title: '',
                imageName: '',
                videoName: '',
                userId: '',
                userData: '',
                artists: '',
                youtube: '',
                FormSubmited: false,
                youtubeFlag: true,
                msg: 'Welcome to Your Vue.js App'
            }
        },
        mounted () {
            if(!this.admin){
                let userdata = localStorage.getItem('cbs_usertoken')
                if(userdata){
                    userdata = JSON.parse(userdata)
                    this.userId = userdata.user.id
                    this.userData = userdata
                }
            } else {
                let userdata = localStorage.getItem('cbs_admin_usertoken')
                if(userdata){
                    userdata = JSON.parse(userdata)
                    this.userData = userdata
                }
                this.adminFunction()
            }
        },
        methods: {
            videoUpload: function(event){
                if(event.target.dataset.id === 'youtube'){
                    this.youtubeFlag = true
                } else {
                    this.youtubeFlag = false
                }
                $('.up-video a').removeClass('active')
                $(event.target).addClass('active')
            },
            adminFunction: function(){
                axios
                    .get('/adminArtists', {
                        headers: {
                            "content-type": "application/json",
                            "x-api-key": this.userData.token
                        }
                    })
                    .then(response => {
                        this.artists = response.data
                    })
                    .catch(error => console.log(error))
            },
            handleImageFileUpload(){
                if(this.$refs.img.files[0]){
                    this.image = this.$refs.img.files[0]
                    this.imageName = this.$refs.img.files[0].name
                }
            },
            handleVideoFileUpload(){
                if(this.$refs.video.files[0]){
                    this.video = this.$refs.video.files[0]
                    this.videoName = this.$refs.video.files[0].name
                }
            },
            pressFormSubmit: function (event) {
                event.preventDefault()
                var $this = this
                this.FormSubmited = true
                const formData = new FormData()
                if(this.youtube){
                    formData.append('youtube', this.youtube)
                } else if(this.video) {
                    formData.append('video', this.video)
                    formData.append('videoName', this.videoName)
                }
                if((this.image && this.video && this.title) || (this.image && this.youtube && this.title)){
                    formData.append('title', this.title)
                    formData.append('image', this.image)
                    formData.append('imageName', this.imageName)
                    formData.append('artistId', this.userId)
                    formData.append('campaignId', this.campaignId)
                    try {
                        axios.post('/sixFeatApartUpload', formData,{
                            headers: {
                                "content-type": "application/json",
                                "x-api-key": this.userData.token
                            }
                        }).then(res => {
                            location.reload()
                            $this.FormSubmited = false
                            console.log(res)
                        }).catch(err => {
                            $this.FormSubmited = false
                            console.log(err)
                        })
                    } catch (e) {
                        console.log(e)
                    }
                } else {
                    this.FormSubmited = false
                    Vue.$toast.open(
                        {
                            message: 'Fill all the fields',
                            type: 'error',
                            position: 'top-right'
                        }
                    )
                }
            },
            pressCreate: function (event) {
                var $this = this
                axios.post('/sixFeatApart', {
                    title: this.title,
                    artistId: this.userId,
                    imagePath: '',
                    imageName: '',
                    videoPath: '',
                    videoName: ''
                },{
                    headers: {
                        "content-type": "application/json",
                        "x-api-key": this.userData.token
                    }
                }).then(function (response) {
                    location.reload()
                    $this.FormSubmited = false
                    Vue.$toast.open(
                        {
                            message: 'Submitted successfully!',
                            type: 'success',
                            position: 'top-right'
                        }
                    )
                    $this.FormSubmited = false
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/include/videoUpload.vue